import React, { createContext, useContext, useEffect, useState } from "react";
import { getBrandingLogoUrl } from "../services/branding.service";

export const DEFAULT_LOGO_URL =
  "https://lirp.cdn-website.com/a85f75f8/dms3rep/multi/opt/LayoutsDB67747D-C218-0AC4-C1B8-2184CDD25E0F.png_400-356w.png";

const BrandingContext = createContext(DEFAULT_LOGO_URL);

type BrandingProviderProps = {
  children: React.ReactNode;
};

export const BrandingProvider = ({ children }: BrandingProviderProps) => {
  const [logoUrl, setLogoUrl] = useState(DEFAULT_LOGO_URL);

  useEffect(() => {
    let isMounted = true;

    getBrandingLogoUrl().then((configuredLogoUrl: string | null) => {
      if (isMounted && configuredLogoUrl) {
        setLogoUrl(configuredLogoUrl);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <BrandingContext.Provider value={logoUrl}>
      {children}
    </BrandingContext.Provider>
  );
};

type BrandLogoProps = React.ImgHTMLAttributes<HTMLImageElement>;

const BrandLogo = (props: BrandLogoProps) => {
  const logoUrl = useContext(BrandingContext);

  return (
    <img
      {...props}
      alt={props.alt || ""}
      src={logoUrl}
      onError={(event) => {
        if (event.currentTarget.src !== DEFAULT_LOGO_URL) {
          event.currentTarget.src = DEFAULT_LOGO_URL;
        }
        props.onError?.(event);
      }}
    />
  );
};

export default BrandLogo;
